import { runsSlice } from '../RunsSlice'
import useSliceWrapper from './useSliceWrapper'

const useGetMethodsAndData = () => useSliceWrapper('runs', runsSlice)

export const useRunsSlice = (): ReturnType<typeof useGetMethodsAndData> => useGetMethodsAndData()

export default useRunsSlice
